<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3WMO4l/tc-custom/9781426855672.jpg?1728726041503" alt="This image is the cover for the book Wedding Garden, Redemption River"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wedding Garden, Redemption River
      </h1>
      <p class="bookDescription body article font2">
        <b>A stunning surprise drives a reformed bad boy back to the high school sweetheart he was forced to leave behind in this inspirational romance.</b><br/><br/>“<i>Are you my Dad?”</i><br/><br/>The young boy’s question shocks Sloan Hawkins. Until Sloan realizes he <i>is</i> this child’s father. Years ago, the former bad boy was run out of Redemption, Oklahoma, where, ironically, he was thought unredeemable. The only people who believed in him were his beloved aunt and Annie Markham, the girl he loved and left behind. Now Sloan is back to face his past and help keep his aunt’s cherished garden thriving. But when he discovers his secret child—and that single mother Annie never stopped loving him—he’s determined that a wedding will take place in the garden nurtured by faith and love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Goodnight
      </h2>
      
      <p class="authorDescription body article">New York Times bestseller Linda Goodnight fell in love with words as a young child when her mother took her to a tiny library and let her fill a cardboard box with books. The next week she was back again, forever hooked on the beauty and power of the written word. Her other passions are her faith and her blended family. A former nurse and teacher, she lives in Oklahoma with her husband where she enjoys baking and travel. Connect with Linda at www.lindagoodnight.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b81f5916